import styled, { css } from 'styled-components'

export const SliceWrapper = styled.div`
  width: 100%;
  background-color: ${props => props.backgroundColor};
  p, a, label, span, [data-key="max-form_title"], h1, h2, h3, cite, ul, li{
    color: ${({ hasDarkBackground }) => (hasDarkBackground ? 'white' : 'inherit')} !important;
  }
  [data-key="max-button"]{
    border: 1px solid  ${({ hasDarkBackground }) => (hasDarkBackground ? 'white' : '#E8E8E8')} !important;
    color: ${({ hasDarkBackground }) => (hasDarkBackground ? 'white' : '#2d2f3d')} !important
  }
  /* Styling for inputs */
[data-key="max-input"] {
  border: 1px solid ${({ hasDarkBackground }) => (hasDarkBackground ? 'white' : '#E8E8E8')} !important;
}

/* Card-specific styling */
[data-key="max-card"] {
  [data-key="max-rich-text"] {
    span, p, li, ul{
      color: #2D2F3D !important;
    }
    a {
      color: #2D2F3D !important;
    }
  }

  [data-key="max-button"] {
    span {
      color: white !important;
    }
  }
}

[data-key="max-modal__box__content"]{
  * {color: #2D2F3D !important;}
}

/* Rich text styling */
[data-key="max-rich-text"] span {
  color: #2D2F3D !important;
}

/* Highlighted state styling */
#isHighlighted span {
  color: white !important;
}

#notHighlighted {
  span {
    color: #2D2F3D !important;
  }

  [data-key="max-card__cta"] span {
    color: ${({ hasDarkBackground }) => (!hasDarkBackground ? 'white' : '#2D2F3D')} !important;
  }
}

/* Featured card content styling */
[data-key="max-feature-card__content"] {
  [data-key="max-button"] {
    span {
      color: white !important;
    }
  }
  [data-key="max-rich-text"] p, h2, [data-key="max-rich-text"] a , ul, li{
    color: #2D2F3D !important;
  }
}

`